// extracted by mini-css-extract-plugin
export default {"TemplateMessage":"CJEmdBccWthzMRVlE4pl","textVariable":"UmSmdTTXOi04ORdZAcep"};